module.exports = __webpack_public_path__ + "img/workout-notebook_B095Q8PBZZ.12f661ab.jpg";